import type { ClientItemId } from 'owa-client-ids';

// NOTE: enum value ordering is used for generating view options menu
export enum CalendarViewType {
    Agenda = 'agenda',
    Day = 'day',
    WorkWeek = 'workweek',
    Week = 'week',
    Month = 'month',
}
export type UserEvent = React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
export type UserEventHandler = (event: UserEvent) => void;
export type CalendarIdChangeHandler = (calendarId: string) => UserEventHandler;
export type ViewTypeChangeHandler = (viewType: CalendarViewType) => UserEventHandler;

export interface CalendarViewBaseProps {
    contextMenuOpen: boolean;
    onContextMenuInvoked: (
        itemId: ClientItemId,
        parentFolderId: string,
        evt: React.MouseEvent<HTMLDivElement>
    ) => void;
    onClickCalendarEvent: (id: string, target?: HTMLElement) => void;
    selectedItemId: string | undefined;
    peekTarget: HTMLElement | undefined;
    setPeekTarget: (target?: HTMLElement) => void;
    onEventsPeekCalloutDismissed: () => void;
}

export interface CalendarPayload {
    calendarIds: string[];
    viewType: CalendarViewType;
    numDaysInDayView?: number;
    title?: string;
}

export interface CalendarHeaderProps extends CalendarPayload {
    isNewlyCreated: boolean | undefined;
    isDragPreview: boolean | undefined;
    isLoaded: boolean;
    onSelectCalendar: CalendarIdChangeHandler;
    scenarioId: string;
    calendarIds: string[];
    title?: string;
    onChangeTitle: (newTitle?: string) => void;
}
export interface CalendarDetailsProps extends CalendarPayload, ExpandableDatePickerProps {
    folderId: string | undefined;
}

export interface ExpandableDatePickerProps {
    selectedDate: Date;
    onSelectDate: (date: Date) => void;
    numDaysInDayView?: number;
    viewType: CalendarViewType;
    onSelectToday: (date: Date) => void;
    showNavigation: boolean;
}

export interface CalendarTitleProps {
    title?: string;
    setTitle: (newTitle?: string) => void;
}
